import React, { Component } from "react";

import { Row, Col, Input, Button, Alert, Container, Label, FormGroup, Form } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import { checkLogin, apiError } from "../../store/actions";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolk from "../../assets/images/LK_Digital Logo.png";

// import videoSrc from "../../assets/images/vid-authentication-bg.mp4";
import { hostLogin } from "../../api/authAPI";
import userIcon from "../../assets/images/auth/LK_User.svg";
import lockIcon from "../../assets/images/auth/LK_Lock.svg";
import eyeOpenIcon from "../../assets/images/auth/LK_Eye Open.svg";
import eyeCloseIcon from "../../assets/images/auth/LK_Eye Close.svg";
import CheckBox from "../Utility/CheckBox";
import { ActiveBtn } from "../Utility/Button";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      isRemember: false,
      isPasswordShown: false,
      forgotPwdHover: false,
      // username: "raju.pillai@lntebg.com",
      // password: "Raju123!",
      // username: "tech@indigoquotient.com",
      // password: "Tech123!",
    };
    /*this.state = {  username : "admin@iqlabs.io", password : "Admin123456" }*/
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { username, password, isRemember } = this.state;
    const formData = { username, password, isRemember };
    console.log("Values: ", formData);

    this.props.checkLogin(formData, this.props.history);
  }

  componentDidMount() {
    this.props.apiError("");
    document.body.classList.add("auth-body-bg");
  }

  componentWillUnmount() {
    document.body.classList.remove("auth-body-bg");
  }

  render() {
    const colour_code = "#004c97";
    return (
      <React.Fragment>
        {/* <div className="home-btn d-none d-sm-block">
          <Link to="/">
            <i className="mdi mdi-home-variant h2 text-white"></i>
          </Link>
        </div> */}

        <div>
          <Container fluid className="p-0" style={{ overflow: "hidden" }}>
            <Row className="no-gutters">
              <Col lg={8}>
                <div className="authentication-bg">
                  <div className="bg-overlay"></div>
                </div>

                {/* <div className="embed-responsive">
                                    <iframe title="video3" className="embed-responsive-item" src="../../assets/images/vid-authentication-bg.mp4"></iframe>
                                </div> */}
              </Col>

              <Col lg={4}>
                <div className="authentication-page-content  d-flex flex-column min-vh-100 ">
                  <Row>
                    <Col sm={2} xs={1}></Col>
                    <Col
                      sm={10}
                      xs={11}
                      style={{
                        height: "91px",
                        marginTop: "40px",
                        borderTopLeftRadius: "98px",
                        borderBottomLeftRadius: "98px",
                        backgroundColor: "#005C8E",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Link to="/" className="logo ">
                        <img src={logolk} style={{ width: "188px", height: "64px", paddingLeft: "6px" }} alt="logo" />
                      </Link>
                    </Col>
                  </Row>

                  <div className="w-100 p-4">
                    <Row className=" justify-content-center">
                      <Col lg={9}>
                        <div style={{ marginTop: "60px" }}>
                          <div className="text-center">
                            <h4 className="fontSize-18 mt-4">Welcome Back !</h4>
                            <p className="text-muted">
                              Sign in to continue to{" "}
                              <span
                                style={{
                                  fontSize: "15px",
                                  color: colour_code,
                                }}
                              >
                                <b>SmartComm CMS</b>
                              </span>
                              .
                            </p>
                          </div>

                          {this.props.loginError && this.props.loginError ? <Alert color="danger">{this.props.loginError}</Alert> : null}

                          <div className="p-2 mt-1">
                            <AvForm className="form-horizontal">
                              <FormGroup className="auth-form-group-custom mb-4">
                                {/* <i style={{ color: colour_code }} className="ri-user-2-line auti-custom-input-icon"></i> */}
                                <img src={userIcon} alt="user icon" style={{ width: "25px", height: "25px" }} className="auti-custom-input-icon" />
                                <Label htmlFor="username">Username</Label>
                                <AvField
                                  name="username"
                                  value={this.state.username}
                                  type="text"
                                  className="form-control"
                                  id="username"
                                  validate={{ email: true, required: true }}
                                  placeholder="Enter username"
                                  onChange={(e) => this.setState({ username: e.target.value })}
                                />
                              </FormGroup>

                              <FormGroup className="auth-form-group-custom mb-4">
                                {/* <i style={{ color: colour_code }} className="ri-lock-2-line auti-custom-input-icon"></i> */}
                                <img src={lockIcon} alt="lock icon" style={{ width: "25px", height: "25px" }} className="auti-custom-input-icon" />
                                <Label htmlFor="userpassword">Password</Label>
                                <AvField
                                  name="password"
                                  value={this.state.password}
                                  type={this.state.isPasswordShown ? "text" : "password"}
                                  className="form-control"
                                  id="userpassword"
                                  placeholder="Enter password"
                                  onChange={(e) => this.setState({ password: e.target.value })}
                                />
                                <img
                                  src={this.state.isPasswordShown ? eyeOpenIcon : eyeCloseIcon}
                                  alt="lock icon"
                                  style={{ cursor: "pointer", position: "absolute", top: "30%", right: "5%", width: "25px", height: "25px" }}
                                  onClick={() => this.setState({ isPasswordShown: !this.state.isPasswordShown })}
                                />
                              </FormGroup>

                              {/* <div className="custom-control custom-checkbox">
                                <Input
                                  name="isRemember"
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customControlInline"
                                  value={this.state.isRemember}
                                  onChange={(e) => this.setState({ isRemember: e.target.checked })}
                                />
                                <Label className="custom-control-label" htmlFor="customControlInline">
                                  Remember me
                                </Label>
                              </div> */}
                              <div style={{ paddingTop: "9px", fontSize: "12pt", position: "relative" }}>
                                <CheckBox label={"Remember me"} checked={this.state.isRemember} checkedData={() => this.setState({ isRemember: !this.state.isRemember })} />
                              </div>
                              <div className="mt-4 d-flex justify-content-center">
                                {/* <Button color="primary" className="w-md waves-effect waves-light" type="submit" onClick={this.handleSubmit}>
                                  Log In
                                </Button> */}

                                <ActiveBtn name={"Log In"} handleClick={this.handleSubmit} />
                              </div>

                              <div
                                className="mt-4 text-center"
                                onMouseOver={() => this.setState({ forgotPwdHover: true })}
                                onMouseLeave={() => this.setState({ forgotPwdHover: false })}
                                style={{ textDecoration: this.state.forgotPwdHover ? "underline" : "none", color: "#005C8E" }}
                              >
                                <Link to="/forgot-password" className="text-muted">
                                  <i className="mdi mdi-lock mr-1"></i> Forgot your password?
                                </Link>
                              </div>
                            </AvForm>
                          </div>

                          <div className="mt-5 text-center">
                            {/* <p>
                              Don't have an account ?{" "}
                              <Link to="/register" className="font-weight-medium text-primary">
                                {" "}
                                Register{" "}
                              </Link>{" "}
                            </p> */}
                            {/*<p>Crafted <i className="mdi mdi-heart text-danger"></i> by iqlabs.io</p> */}
                            {false && (
                              <p>
                                powered by
                                <span style={{ "font-size": "20px" }}>
                                  <b> iqlabs.io</b>
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { loginError } = state.Login;
  return { loginError };
};

export default withRouter(connect(mapStatetoProps, { checkLogin, apiError })(Login));
